// helpers/validationSchema.ts
import * as yup from "yup";

export interface IFormData {
	paymentMethod: string;
	fee: string;
	lessorName: string;
	lessorCpf: string;
	assuranceMonthAmount: string;
	lmi: string;
	lmiAmount: string;
	lessorTypePerson: string;
	lessorBirthDate?: string;
	lessorEmail: string;
	rentMonthsCount: string;
	termBegin: string;
	planId?: string;
	lessorPhone: string;
	lessorMobilePhone?: string;
	email?: string;
	contractBegin: string;
	contractEnd: string;
	sendClick?: string;
	setup_tax?: string;
	setup_amount?: string;
	addressNumber?: string;
	addressStreet?: string;
	addressDistrict?: string;
	addressComplement?: string;
	addressZipcode?: string;
	addressCity?: string;
	addressState?: string;
}

const createRequiredMessage = (fieldName: string) => `Campo ${fieldName} é obrigatório`;

export const formValidationSchema: yup.SchemaOf<IFormData> = yup.object().shape({
	paymentMethod: yup.string().required(createRequiredMessage("Forma de pagamento")),
	fee: yup.string().required(createRequiredMessage("Taxa")),
	lessorName: yup.string().required(createRequiredMessage("Nome do locador")),
	lessorCpf: yup.string().required(createRequiredMessage("CPF do locador")),
	assuranceMonthAmount: yup.string().required(createRequiredMessage("Valor mensal")),
	lmi: yup.string().required(createRequiredMessage("LMI")),
	lmiAmount: yup.string().required(createRequiredMessage("Valor LMI")),
	lessorTypePerson: yup.string().required(createRequiredMessage("Tipo de pessoa")),
	lessorBirthDate: yup.string().when("lessorTypePerson", {
		is: "PF",
		then: yup.string().required(createRequiredMessage("Data de nascimento")),
		otherwise: yup.string().notRequired(),
	}),
	lessorEmail: yup.string().required(createRequiredMessage("E-mail do locador")),
	rentMonthsCount: yup.string().required(createRequiredMessage("Quantidade de meses")),
	termBegin: yup.string().required(createRequiredMessage("Início da vigência")),
	planId: yup.string().notRequired(),
	lessorPhone: yup.string().required(createRequiredMessage("Celular do locador")),
	lessorMobilePhone: yup.string().notRequired().default(""),
	email: yup.string().notRequired().default(""),
	contractBegin: yup.string().required(createRequiredMessage("Início do contrato")),
	contractEnd: yup.string().required(createRequiredMessage("Fim do contrato")),
	sendClick: yup.string().notRequired().default(""),
	setup_tax: yup.string().notRequired().default(""),
	setup_amount: yup.string().notRequired().default(""),
	addressNumber: yup.string().notRequired(),
	addressCity: yup.string().notRequired(),
	addressState: yup.string().notRequired(),
	addressComplement: yup.string().notRequired(),
	addressDistrict: yup.string().notRequired(),
	addressZipcode: yup.string().notRequired(),
	addressStreet: yup.string().notRequired(),
});
